import React, {useCallback, useEffect, useRef, useState} from "react";
import {StyleSheet, Text, View, SafeAreaView, Pressable, Button, StatusBar, FlatList} from "react-native";
import {TaskItem} from "../component/TaskItem";
import ViewCompletedButton from "../component/ViewCompletedButton";
import {useSelector, useDispatch} from 'react-redux';
import {MainMenu} from "../component/MainMenu";
import {loadLang, loadSettings, loadTasks, loadTheme} from "../function/functions";
import {useTranslation} from "react-i18next";
import {useTheme} from "@react-navigation/native";
import Moment from "moment";
import {FontAwesome} from "@expo/vector-icons";
import * as WebBrowser from "expo-web-browser";
import * as Google from "expo-auth-session/providers/google";
import {FlashList} from "@shopify/flash-list";

export const HomeScreen = (props) => {
    const date = useSelector(state => state.date);
    let tasks = useSelector(state => state.tasks);
    const total = useSelector(state => state.total);
    const completed = useSelector(state => state.completed);
    const settings = useSelector(state => state.settings);
    const viewCompleted = useSelector(state => state.viewCompleted);
    const activeTheme = useSelector(state => state.theme);
    const theme = useTheme();
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [reload, setReload] = useState(false);
    const flatListRef = useRef();
    const currentLang = useSelector(state => state.lang);
    let DATA = [];

    useEffect(() => {
        i18n.changeLanguage(currentLang).then(r => {});
    }, [currentLang]);
    useEffect(() => {
        props.setTheme(activeTheme)
    }, [activeTheme]);
    useEffect(() => {
        DATA = [];
        Object.keys(tasks).map((prop, key) => {
            if (tasks[prop].complete === viewCompleted || !settings.viewtask.enabled)
                DATA.push(tasks[prop]);
        })
    }, [tasks, viewCompleted]);
    useEffect(() => {
        if (Object.keys(tasks).length === 0 || reload) {
            loadSettings(dispatch);
            loadTasks(dispatch, {from: date, to: date});
            setReload(false);
        } //{from:'03.05.2023', to:'13.05.2023'}
        loadTheme(dispatch);
        loadLang(dispatch);
        props.setTheme(activeTheme)
    },[date])

    DATA = [];
    Object.keys(tasks).map((prop, key) => {
        if (tasks[prop].complete === viewCompleted || !settings.viewtask.enabled)
            DATA.push(tasks[prop]);
    })

    const styles = StyleSheet.create({
        none: {
            display:'none'
        },
        flexRow: {
            width:'100%',
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
        },
        taskSwitcherWrapper: {
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            width:'100%'
        },
        taskSwitcher: {
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            alignItems:'center',
            borderWidth: 0,
            backgroundColor:theme.colors.scheme[4],
            borderRadius:100,
            paddingVertical:2
        },
        taskWrapper: {
            width:'100%',
            maxWidth:800,
            marginHorizontal:4
        },
        container: {
            width: '100%',
            height:'100%',
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            backgroundColor:theme.colors.scheme[3],
        },
        date: {
            textAlign: 'center',
            fontSize: 24,
            fontFamily: 'Roboto-Regular',
            color:theme.colors.scheme[2],
            marginHorizontal: 12
        },
        dateSwitchButton: {
            width:32,
            height:32,
            borderRadius: 32,
            display:'flex',
            flexDirection:'row',
            alignItem:'center',
            justifyContent:'center',
        },
        dateSwitchButtonIcon: {
            lineHeight:32,
            fontSize: 18,
            color:theme.colors.scheme[2]
        },
        counterWrapper: {
            height:80,
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
        },
        counter: {
            width: '100%',
            textAlign: 'center',
            fontSize: 48,
            fontFamily: 'Roboto-Black',
            color:theme.colors.scheme[2],
        },
        list: {
            width: '100%',
            flexGrow:1,
            paddingBottom:72
        },
        item: {
            backgroundColor: '#f9c2ff',
            padding: 20,
            marginVertical: 8,
            marginHorizontal: 16,
        },
        title: {
            fontSize: 32,
        }
    });
    const renderTask = ({item}) => { return(<TaskItem task={item} />)}

    const footer = React.memo(() => {
        return (<View style={{flexGrow:1}}>{completed === 0 && viewCompleted && total > 0 && settings.viewtask.enabled ?
            <Text style={{flex:1, textAlign:'center', paddingBottom:12, fontSize:24, fontFamily:'Roboto-Black', lineHeight:32, color:theme.colors.scheme[5]}}>{t('alerts.completedEmpty')}</Text>
            :
            null}
            {completed === 0 && total === 0 && settings.viewtask.enabled ?
                <Text style={{flex:1, textAlign:'center', paddingBottom:12, fontSize:24, fontFamily:'Roboto-Black', lineHeight:32, color:theme.colors.scheme[5]}}>{t('alerts.allEmpty')}</Text>
                :
                null}
            {completed > 0 && total === completed && ((settings.viewtask.enabled && !viewCompleted) || !settings.viewtask.enabled) ?
                <Text style={{flex:1, textAlign:'center', paddingBottom:12, fontSize:24, fontFamily:'Roboto-Black', lineHeight:32, color:theme.colors.scheme[5]}}>{t('alerts.allCompleted')}</Text>
                :
                null}
            {!settings.viewtask.enabled || !viewCompleted ? <MainMenu navigation={props.navigation} /> : <View style={{paddingVertical:64}}></View>}
        </View>)
    })
    const header = React.memo(() => {
        return (<View style={{paddingBottom: 24}}><View style={[styles.flexRow, {flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingTop:16}]}>
            <Pressable style={(({pressed}) => [styles.dateSwitchButton, {opacity: (pressed ? 0.5 : 1), backgroundColor:(pressed ? theme.colors.scheme[4] : theme.colors.scheme[3])}])}
                       onPress={() => {
                           setReload(true);
                           dispatch({type:'CHANGE_DATE', payload: Moment(date, 'DD.MM.YYYY').subtract(1, 'days').format('DD.MM.YYYY')})
                       }}>
                <FontAwesome style={styles.dateSwitchButtonIcon} name={'arrow-left'} />
            </Pressable>
            <Text style={styles.date}>{date}</Text>
            <Pressable style={(({pressed}) => [styles.dateSwitchButton, {opacity: (pressed ? 0.5 : 1), backgroundColor:(pressed ? theme.colors.scheme[4] : theme.colors.scheme[3])}])}
                       onPress={() => {
                           setReload(true);
                           dispatch({type:'CHANGE_DATE', payload: Moment(date, 'DD.MM.YYYY').add(1, 'days').format('DD.MM.YYYY')})
                       }}><FontAwesome style={styles.dateSwitchButtonIcon} name={'arrow-right'} /></Pressable>
        </View>
            <View style={[styles.flexRow, styles.counterWrapper]}><Text style={styles.counter}>{completed}/{total}</Text></View>
            {
                settings.viewtask.enabled ?
                    <View style={styles.taskSwitcherWrapper}>
                        <View style={styles.taskSwitcher}>
                            <View><ViewCompletedButton title={t('home.active')} data={false} onPress={
                                () => {
                                    dispatch({type: 'CHANGE_VIEWTASK', payload: {viewCompleted: false}})
                                }} /></View>
                            <View><ViewCompletedButton title={t('home.completed')} data={true} onPress={
                                () =>
                                    dispatch({type:'CHANGE_VIEWTASK', payload:{viewCompleted: true}})} /></View>
                        </View>
                    </View>
                    : null
            }</View>)
    })
    const _keyExtractor = (item) => item.id
    return (
        <SafeAreaView style={styles.container}>
            <StatusBar barStyle={theme.colors.barStyle} backgroundColor={theme.colors.scheme[3]} />
            <View style={styles.taskWrapper}>
                <FlashList
                    ListHeaderComponent={header}
                    ListFooterComponent={footer}
                    data={DATA}
                    renderItem={renderTask}
                    keyExtractor={_keyExtractor}
                    estimatedItemSize={101}
                    removeClippedSubviews={true}
                    initalItemToRender={2}
                    initialNumToRender={2}
                    maxToRenderPerBatch={1}
                    windowSize={7}
                    updateCellsBatchingPeriod={100}
                    onEndReachedThreshold={10}
                    showsVerticalScrollIndicator={false}
                />
            </View>
        </SafeAreaView>
    )
}